import React from "react";
import { Link } from "react-router-dom";

const AboutTab = ({
  userDetails,
  userExperiences,
  userSkills,
  userEmail,
  userLanguage,
}) => {
  return (
    <div className="exprt_overviewOuter">
      <div className="network_details_item mb-4">
        <div className="contnt_hdng mb-3">
          <h3 className="fs-lg text-uppercase">About</h3>
        </div>
        <div className="results_para">
          <p
            className="mb-4"
            dangerouslySetInnerHTML={{ __html: userDetails }}
          ></p>
        </div>
      </div>
      <div className="network_details_item mb-4">
        <div className="contnt_hdng mb-3">
          <h3 className="fs-lg text-uppercase">Experience</h3>
        </div>
        <div className="experience_pnl">
          <div className="dates_pnlOuter">
            {userExperiences.map((experience, index) => {
              return (
                <div
                  className="dates_pnlItem experice_item d-flex gap-3 align-items-start pb-4 position-relative"
                  key={index}
                >
                  <span className="dates_nmbr exprince_logo rounded-circle bg-white overflow-hidden d-flex align-items-center justify-content-center position-relative">
                    {/* <img src="images/exprt-logo1.png" alt="" /> */}
                    <i className="material-icons-outlined fs-lg">apartment</i>
                  </span>
                  <div className="experience_hdng">
                    <h4 className="fs-sm fw-bold text-uppercase mb-2 text-primary">
                      {experience.position} <span>{experience.company}</span>
                    </h4>
                    <h5 className="fs-sm mb-2">
                      {experience.start} to {experience.end}
                    </h5>
                    {/* <div className="d-inline-flex align-items-center gap-1 exp_tag rounded-90 bg-white px-3 py-2">
                                <i className="material-icons-outlined fs-md">
                                  place
                                </i>
                                <span>Madrid, Spain</span>
                              </div> */}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      <div className="network_details_item mb-4">
        <div className="contnt_hdng mb-3">
          <h3 className="fs-lg text-uppercase">Skills</h3>
        </div>
        <div className="users_skill activity_skill">
          <ul className="list_style_none d-flex align-items-center gap-2 flex-wrap">
            {userSkills.map((skill, index) => {
              return (
                <li key={index}>
                  <Link
                    to="#"
                    className="d-flex align-items-center py-2 px-3 bg-white rounded-4 fs-sm"
                  >
                    {skill.name}
                  </Link>
                </li>
              );
            })}
          </ul>
        </div>
      </div>

      <div className="network_details_item">
        <div className="contnt_hdng mb-3">
          <h3 className="fs-lg text-uppercase">Additional Information</h3>
        </div>
        <div className="user_aditonal_outer">
          <div className="row">
            <div className="col-lg-3 col-md-6 col-6">
              <div className="additional_info ">
                <h4 className="d-flex align-items-center gap-1 fs-sm text-primary-gray mb-1">
                  <i className="material-icons-outlined gredient-icon fs-lg">
                    email
                  </i>{" "}
                  Email
                </h4>
                <Link to="#" className="text-primary fs-sm fw-medium">
                  {userEmail}
                </Link>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-6">
              <div className="additional_info ">
                <h4 className="d-flex align-items-center gap-1 fs-sm text-primary-gray mb-1">
                  <i className="material-icons-outlined gredient-icon fs-lg">
                    language
                  </i>{" "}
                  Language
                </h4>
                <h5 className="text-primary fw-medium fs-sm">{userLanguage}</h5>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutTab;
